import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Popup, PopupContent, Button } from 'ui';

import s from './ContactSuccessPopup.module.scss';

const cx = cn.bind(s);

const ContactSuccessPopup = ({
  isOpen, onClose, className, ...attrs
}) => (
  <Popup isOpen={isOpen} {...attrs} onClose={onClose}>
    <PopupContent title="Your message has been sent" onClose={onClose}>
      <p className={cx('tp-text')}>
        Thanks for contacting us! We will get in touch with you shortly.
      </p>
      <div className={cx('actionRow')}>
        <Button href="/" as="a">
          Back to main
        </Button>
      </div>
    </PopupContent>
  </Popup>
);

ContactSuccessPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default ContactSuccessPopup;
